"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskFromOperationNode = exports.taskToOperationNode = exports.operationConvertors = void 0;
const common_1 = require("@finley-technologies/common");
const converter_1 = require("./operations/attachHeader/converter");
const converter_2 = require("./operations/edit/converter");
const converter_3 = require("./operations/filter/converter");
const converter_4 = require("./operations/flatten/converter");
const converter_5 = require("./operations/join/converter");
const converter_6 = require("./operations/pdf2csv/converter");
const converter_7 = require("./operations/preFilter/converter");
const converter_8 = require("./operations/sanitize/converter");
const converter_9 = require("./operations/unzip/converter");
const converter_10 = require("./operations/xlsx2csv/converter");
exports.operationConvertors = {
    attachHeader: converter_1.convertor,
    edit: converter_2.convertor,
    filter: converter_3.convertor,
    flatten: converter_4.convertor,
    join: converter_5.convertor,
    pdf2csv: converter_6.convertor,
    preFilter: converter_7.convertor,
    sanitize: converter_8.convertor,
    xlsx2csv: converter_10.convertor,
    unzip: converter_9.convertor,
};
const operationConvertorArray = Object.values(exports.operationConvertors);
const getConvertorByOperation = (operation) => {
    const converter = operationConvertorArray.find((con) => con.operation === operation);
    (0, common_1.finleyAssert)(converter, `no converter found for operation: ${operation}`);
    return converter;
};
const getConvertorByNodeType = (nodeType) => {
    const converter = operationConvertorArray.find((con) => con.nodeType === nodeType);
    (0, common_1.finleyAssert)(converter, `no converter found for nodeType: ${nodeType}`);
    return converter;
};
const taskToOperationNode = ({ task }) => {
    const converter = getConvertorByOperation(task.operation);
    return converter.taskToOperationNode(task);
};
exports.taskToOperationNode = taskToOperationNode;
const taskFromOperationNode = ({ srcNodes, operationNode, }) => {
    const converter = getConvertorByNodeType(operationNode.metadata.tapeBuilderNodeType);
    return converter.taskFromOperationNode({ srcNodes, operationNode });
};
exports.taskFromOperationNode = taskFromOperationNode;
//# sourceMappingURL=operationConvertors.js.map